export default {
  EN: 'en-US',
};
